import { FC, ReactElement, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import isUITest from '../../utils/is-ui-test';
import usercentrics from '../../services/usercentrics';

type ConsentSensitiveProps = {
    children: ReactNode | ReactElement | string;
    type: string | string[];
};

const ConsentSensitive: FC<ConsentSensitiveProps> = ({ children, type }) => {
    const cookieConsent = useSelector((state: RootState) => state.main.cookieConsent);
    const isCookieAccepted = usercentrics.isServiceAccepted(cookieConsent.services, type);

    // Don't block content for UI tests
    if (isCookieAccepted || isUITest()) {
        return <>{children}</>;
    }

    return null;
};

export default ConsentSensitive;
